import { Modal } from 'antd';
import moment from 'moment-timezone';
import React from 'react';
import { DEFAULTDATETIMEFORMAT } from '../../../../../../../common/constants';
import CommonTable from '../../../../../../../components/CommonTable';

const EqcRenameModal = ({ showModal, setShowModal, data, projectData }) => {
  const columns = [
    {
      title: 'Old Name',
      dataIndex: 'oldName',
    },
    {
      title: 'New Name',
      dataIndex: 'newName',
    },
    {
      title: 'Renamed By',
      dataIndex: 'action',
      render: (obj) => obj?.name,
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      render: (obj) =>
        moment(obj)
          ?.tz(projectData?.getProject?.timeZone)
          ?.format(DEFAULTDATETIMEFORMAT),
    },
  ];
  return (
    <Modal
      maskClosable={false}
      open={showModal}
      onCancel={() => setShowModal(false)}
      footer={false}
      width={720}
    >
      <h2>EQC Rename History</h2>
      <CommonTable
        dataSource={data}
        columns={columns}
        rowKey={(obj) => obj?.id}
      />
    </Modal>
  );
};
export default EqcRenameModal;
